import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useIntersection from 'ggApp/shared/hooks/useIntersection';

import VimeoEmbed from 'ggApp/shared/components/VimeoEmbed/VimeoEmbed';

import { Container } from './styles';

const Player = ({ config: { id }, className, options, onEnterCallback, onExitCallback }) => {
    const nodeRef = useRef(null);

    useIntersection({ node: nodeRef, onExitCallback, onEnterCallback });

    return (
        <Container className={className} ref={nodeRef}>
            <VimeoEmbed
                playerId="pdp-product-video-"
                controlsPosition="bottomLeft"
                id={id}
                options={options}
            />
        </Container>
    );
};

Player.propTypes = {
    config: PropTypes.shape({}).isRequired,
    options: PropTypes.shape({
        preload: PropTypes.bool, // if true, video shouldn't have black background on 0.0 seconds
        title: PropTypes.string,
    }),
    className: PropTypes.string,
    onExitCallback: PropTypes.func,
    onEnterCallback: PropTypes.func,
};

Player.defaultProps = {
    options: {},
    className: '',
    onExitCallback: undefined,
    onEnterCallback: undefined,
};

export default Player;
